<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Factory' }">生产配额</el-breadcrumb-item>
          <el-breadcrumb-item>新建帐号</el-breadcrumb-item>
        </el-breadcrumb>
    <el-row style="padding: 30px">
      <el-col :span="12" >
        <el-form
          :model="customer"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
           <el-form-item label="名称" prop="name">
            <el-input v-model="customer.name" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="customer.username" maxlength="20" ></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="orgpassword">
            <el-input
              v-model="customer.orgpassword"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码确认" prop="password2">
            <el-input
              v-model="customer.password2"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
            <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="createUser()">创建</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../../assets/js/md5'
export default {
  name: 'CreateUser',
  data () {
    var passwordCheck = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    var password2Check = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else if (value !== this.customer.orgpassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      customer: {
        name: '',
        password: '',
        orgpassword: '',
        password2: '',
        username: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        orgpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: passwordCheck, trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: password2Check, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    let user = window.localStorage.getItem('customer')
    if (user) {
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    createUser () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          self.customer.password = hex_md5(self.customer.orgpassword)
          self.customer.orgpassword = ''
          self.customer.password2 = ''
          Vue.axios
            .post('/produce/add',
              self.customer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '帐号创建成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
                self.disabled = false
              }
            })
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .el-upload-list--picture-card .el-upload-list__item {
     width: 100px;
  height: 100px;
    line-height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
   width: 100px;
  height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
   width: 100px;
  height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Produce/Add.vue